import { Observable } from 'rxjs';
import {
  Cantiere,
  CreateCantiereDto,
  UpdateCantiereDto,
  PaginatedResponse,
  CantieriQueryParams,
  CreateCantiereFromPreventivoDto, ContrattoCantiere, CantierePieStats, CantiereFlussoMensileStats,
} from '../../models/cantieri.model';

// Contratto astratto del servizio Cantieri.
// Gli effects dipendono da questa porta, non dall'implementazione HTTP concreta.
export abstract class CantieriPort {
  // Lista paginata con filtri/sort.
  abstract getList(params?: CantieriQueryParams): Observable<PaginatedResponse<Cantiere>>;
  // Dettaglio singolo cantiere.
  abstract getById(id: number): Observable<Cantiere>;
  // Creazione cantiere.
  abstract create(
    dto: CreateCantiereDto,
    contratto?: File | null
  ): Observable<number>;
  // Aggiornamento campi cantiere.
  abstract update(id: number, changes: UpdateCantiereDto): Observable<Cantiere>;
  // Eliminazione cantiere.
  abstract delete(id: number): Observable<void>;
  // Cambio stato archivio.
  abstract archive(id: number): Observable<number>;
  abstract unarchive(id: number): Observable<number>;
  // Conclusione cantiere con data consegna.
  abstract end(id: number, dataConsegna: string): Observable<number>;
  // Associazioni relazionali.
  abstract associateDipendente(id: number, idDipendente: number, associate: boolean): Observable<number>;
  abstract associateFornitore(id: number, idFornitore: number, associate: boolean): Observable<number>;
  // Conversione da preventivo.
  abstract createFromPreventivo(dto: CreateCantiereFromPreventivoDto): Observable<number>;
  // Verifica se un fornitore e gia associato al cantiere.
  abstract isAssociatedTo(id: number, idFornitore: number): Observable<boolean>;

  abstract getContrattiByCantiere(
    idCantiere: number
  ): Observable<ContrattoCantiere[]>;

  abstract createContrattoCantiere(
    idCantiere: number,
    file: File,
    descrizione?: string
  ): Observable<number>;

  abstract updateContrattoCantiere(
    id: number,
    file?: File | null,
    descrizione?: string
  ): Observable<number>;

  abstract deleteContrattoCantiere(
    id: number
  ): Observable<void>;

  abstract previewFile(
    fileId: number
  ): Observable<Blob>;

  abstract getPieByIdCantiere(
    idCantiere: number
  ): Observable<CantierePieStats>;

  abstract getFlussoMensileByIdCantiere(
    idCantiere: number
  ): Observable<CantiereFlussoMensileStats[]>;


}
